import script from "./BalChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalChip.vue?vue&type=script&setup=true&lang=ts"

import "./BalChip.vue?vue&type=style&index=0&id=49f282fc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f282fc"]])

export default __exports__